import Home from "../pages/commalax-landing/home";
import { useEffect } from "react";
import logo from "../assets/images/commalax-landing/favicon.png";
const CommalaxLanding = () => {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    const title = document.querySelector("head title");
    if (favicon) favicon.href = logo;
    title.textContent = "Commalax";
  }, []);
  return (
    <div id="commalax">
      <Home />
    </div>
  );
};

export default CommalaxLanding;
